import React, { Component } from 'react';
import { Flex, Modal, Toast } from 'antd-mobile';
import './SkuModalLess.less';
import Util from 'utils';
import { Stepper, CheckBox } from 'widget';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import _ from 'lodash';
import { checkShowTipModal } from 'biz-micro-services-ui/project/middlePlatform/function/common';

@inject('CheckOrderMod')
@inject('ShoppingCartMod')
@inject('QuickBuyMod')
@inject('AppMod')
@observer
export default class SpecModal extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  // 多规格商品
  moreSpecificationsList = () => {
    const { productMod, skutype, productMsgMap } = this.props;
    const {
      productInfo,
      moreSpecificationsData,
      checkItem,
      skuCheckLists,
      selectedProducts,
      activityType,
      activityInfo
    } = productMod;
    const { discountSalePrice, discountBv, limitBuyCount } = activityInfo || {};
    // console.log('多规格===',toJS(productInfo).subItemList);
    let _moreSpecificationsData = _.cloneDeep(toJS(moreSpecificationsData));
    let _checkItem = _.cloneDeep(toJS(checkItem));
    let _skuCheckLists = _.cloneDeep(toJS(skuCheckLists));
    let _productInfo = _.cloneDeep(toJS(productInfo));
    let _selectedProducts = _.cloneDeep(toJS(selectedProducts));
    // let _productMsgMap = toJS(Object.assign({}, productMsgMap));
    let obj = { ...productMsgMap };
    // console.log('_productInfo===>',_productInfo);
    // console.log('selectedProducts===>',_selectedProducts);
    // console.log('productMsgMap===>',obj);
    let lists = (_skuCheckLists && _skuCheckLists[_productInfo.itemSerial]) || [];
    if (lists.length > 0) {
      lists.map((el) => {
        _moreSpecificationsData.forEach((ele) => {
          if (el.itemSerial == ele.itemSerial) {
            ele.checked = el.checked;
            ele.num = el.num;
            ele.itemNum = el.num;
          }
        });
      });
    }
    let isCheck = !!Object.keys(_checkItem).length;
    // 当有选中的值 将商品第一栏显示改成选中的内容 (且不是快速购物进来 快速购物skutype == quickBuy)
    let itemData =
      Object.keys(_checkItem).length > 0 && skutype != 'quickBuy' ? _checkItem : _productInfo;
    let imgUrl =
      itemData.imgUrl || (itemData.mediaRespDtoList && itemData.mediaRespDtoList[0].path1);
    const showIntegration = itemData.integration > 0 && this.props.isSelectMall;
    return (
      <div className="add_list">
        <Flex className="wrapper">
          <img src={imgUrl ? Util.getImgUrl(imgUrl, 320) : ''} />
          <Flex direction="column" align="start" justify="between" className="info">
            <Flex direction="column" align="start">
              <span className="productName">
                {itemData.originName || itemData.itemName || itemData.name}
              </span>
              <span className="fz-22 color-light-grey">{itemData.code}</span>
            </Flex>
            <Flex className="price-box" justify="between">
              <span className="fz-28 color-gold fw-bold">
                {showIntegration
                  ? `${this.props.AppMod.selectMallCoinLabel} ${itemData.integration}`
                  : Util.formatMoney(
                      +activityType === 10 && !isCheck
                        ? discountSalePrice
                        : itemData.price || itemData.discountSalePrice || 0
                    )}
                {!isCheck && itemData.price < itemData.maxPrice && (
                  <span className="pro_up">{'起'}</span>
                )}
              </span>
            </Flex>
          </Flex>
        </Flex>
        <div className="info_wrap">
          <Flex>选择规格</Flex>
          {_moreSpecificationsData &&
            _moreSpecificationsData.length > 0 &&
            _moreSpecificationsData.map((item, index) => {
              let _img = item.imgUrl || (item.mediaRespDtoList && item.mediaRespDtoList[0].path1);
              const clildIntegration = item.integration;
              const showClildIntegration = clildIntegration > 0 && this.props.isSelectMall;
              return (
                <div key={index} style={{ display: 'flex' }}>
                  <div style={{ height: '120px', lineHeight: '120px', marginRight: '20px' }}>
                    <CheckBox
                      checked={item.checked}
                      disabled={false}
                      onClick={async () => {
                        let _check = false;
                        // 如果是99微购商品，则不加入购物车，弹窗提示
                        if (await this.renderMicroShopModal(item)) {
                          return;
                        }
                        _moreSpecificationsData.forEach((ele) => {
                          if (ele.code ? ele.code == item.code : ele.itemCode == item.itemCode) {
                            ele.checked = ele.checked ? !ele.checked : true;
                            _check = ele.checked;
                            if (skutype != 'quickBuy') {
                              ele.num = 1;
                            } else {
                              ele.num = item.num || 1;
                            }
                          } else {
                            if (skutype != 'quickBuy') {
                              ele.checked = false;
                            }
                          }
                        });

                        let _checkItem = _check ? item : {};
                        let _skuCheckList = [];
                        _moreSpecificationsData.find((el) => {
                          el.itemNum = el.num;
                          !!el.checked && _skuCheckList.push(el);
                        });
                        if (_skuCheckLists) {
                          _skuCheckLists[_productInfo.itemSerial] = _skuCheckList;
                          // _skuCheckList.length > 0 &&
                          // (obj[_productInfo.itemSerial].selected = true);
                          // !(_skuCheckList.length > 0) &&
                          // (obj[_productInfo.itemSerial].selected = false);
                          // const isSelected = _skuCheckList.length > 0 ? true : false
                          // !(isSelected == obj[_productInfo.itemSerial].selected) && (obj[_productInfo.itemSerial].selected = isSelected)
                          // console.log(obj, '>>>>>>>');
                          this.props.callback &&
                            this.props.callback({
                              params: obj,
                              skuCheckLists: _.cloneDeep(_skuCheckLists)
                            });
                        }
                        if (skutype == 'quickBuy') {
                          this.props.productMod.changeState(
                            'moreSpecificationsData',
                            _moreSpecificationsData
                          );
                          this.props.productMod.changeState('skuCheckLists', _skuCheckLists);
                        } else if (skutype == 'quick') {
                          this.props.productMod.changeState(
                            'moreSpecificationsData',
                            _moreSpecificationsData
                          );
                          this.props.productMod.changeState('checkItem', _checkItem);
                        } else {
                          this.props.productMod.changeState({
                            moreSpecificationsData: _moreSpecificationsData,
                            checkItem: _checkItem
                          });
                        }
                      }}
                      className="check-b"
                    />
                  </div>
                  <div key={item.itemSerial} className="info_center">
                    <div
                      className="info_item"
                      style={
                        {
                          // border: !!item.checked? '1px solid #A5762B' : 'none',
                          // color: !!item.checked? '#A5762B' : '#00000099',
                        }
                      }
                      onClick={() => {}}>
                      <img src={_img ? Util.getImgUrl(_img, 100) : ''} alt="" />
                      <Flex className="_right">
                        <div className="_name">{item.itemName || item.name}</div>
                        <div className="_price">
                          <Flex align="end">
                            {showClildIntegration
                              ? `${this.props.AppMod.selectMallCoinLabel} ${clildIntegration}`
                              : Util.formatMoney(item.price || item.discountSalePrice || 0)}
                          </Flex>
                          {!!item.checked && skutype == 'quickBuy' && (
                            <Stepper
                              min={item.minNumber || 1}
                              max={item.onceLimitNum || 999}
                              value={item.num || 1}
                              onChange={(value) => {
                                // console.log('----------',value);
                                if (
                                  (item.minNumber || item.minSaleNum) &&
                                  value < (item.minNumber || item.minSaleNum)
                                ) {
                                  Toast.info('亲，不能再少了');
                                  return;
                                } else {
                                  if (item.onceLimitNum && item.onceLimitNum < value) {
                                    Toast.info('亲，不能再多了');
                                    return;
                                  }
                                }
                                _moreSpecificationsData.forEach((ele) => {
                                  if (
                                    ele.code ? ele.code == item.code : ele.itemCode == item.itemCode
                                  ) {
                                    ele.num = value;
                                    ele.itemNum = value;
                                  }
                                });
                                let _skuCheckList = [];
                                _moreSpecificationsData.find((el) => {
                                  !!el.checked && _skuCheckList.push(el);
                                });
                                if (_skuCheckLists) {
                                  _skuCheckLists[_productInfo.itemSerial] = _skuCheckList;
                                }
                                if (skutype == 'quickBuy') {
                                  this.props.productMod.changeState(
                                    'moreSpecificationsData',
                                    _moreSpecificationsData
                                  );
                                  // this.props.callback && this.props.callback({skuCheckLists:_.cloneDeep(_skuCheckLists)})
                                  this.props.productMod.changeState(
                                    'skuCheckLists',
                                    _skuCheckLists
                                  );
                                } else if (skutype == 'quick') {
                                  this.props.productMod.changeState(
                                    'moreSpecificationsData',
                                    _moreSpecificationsData
                                  );
                                } else {
                                  this.props.productMod.changeState({
                                    moreSpecificationsData: _moreSpecificationsData
                                  });
                                }
                              }}
                            />
                          )}
                        </div>
                      </Flex>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  };
  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  }
  renderMicroShopModal = async (item) => {
    const { code, itemCode, name, itemName, itemSerial, id, itemId } = item;
    const v = await checkShowTipModal({
      code: code || itemCode,
      name: name || itemName,
      activity: '99微购',
      itemId: itemSerial || id || itemId
    });
    return v;
  };
  confirm = () => {
    const { productMod, skutype } = this.props;
    const { checkItem, activityType } = productMod;
    let newParam = {};
    if (skutype == 'quickBuy') {
      this.props.productMod.changeState('showSkuModal', false);
      return;
    }
    console.log('activityType', activityType, checkItem);
    if (Object.keys(checkItem).length == 0) {
      Toast.info('请选择多规格商品', 2);
    } else {
      newParam = {
        itemName: checkItem.name,
        itemNum: checkItem.num,
        // itemSerial: (+activityType == '10' ? checkItem.itemId : checkItem.id )|| checkItem.itemId,
        itemSerial: checkItem.id || checkItem.itemId,
        skuSerial: checkItem.skuId,
        price: checkItem.price || checkItem.discountSalePrice
      };

      if (this.props.sourceTag) {
        newParam.referrer = `${this.props.sourceTag}-加入购物车`;
      }

      if (this.props.isSelectMall) {
        this.props.ShoppingCartMod.addSelectMallCart(newParam, 0).then((result) => {
          if (result) {
            Toast.info('加入购物车成功', 2);
            if (skutype == 'quick') {
              this.props.productMod.changeState('showSkuModal', false);
              this.props.productMod.changeState('checkItem', {});
            } else {
              this.props.productMod.changeState({
                showSkuModal: false,
                checkItem: {}
              });
            }
          }
        });
      } else {
        this.props.ShoppingCartMod.addCart(newParam).then((result) => {
          if (result) {
            Toast.info('加入购物车成功', 2);
            if (skutype == 'quick') {
              this.props.productMod.changeState('showSkuModal', false);
              this.props.productMod.changeState('checkItem', {});
            } else {
              this.props.productMod.changeState({
                showSkuModal: false,
                checkItem: {}
              });
            }
          }
        });
      }
    }
    this.props.onConifrm && this.props.onConifrm();
  };

  render() {
    const { productMod } = this.props;
    const { productInfo } = productMod;
    let _productInfo = _.cloneDeep(toJS(productInfo));
    return (
      <div style={{ backgroundColor: '#fff' }}>
        <Modal
          className="product-detail-sku-modal"
          transparent
          popup
          visible={this.props.visible}
          animationType="slide-up"
          closeOnAction={true}
          closeOnMaskClick={true}
          onClose={() => {
            this.props.onClose && this.props.onClose();
          }}>
          <div
            style={{
              height: 800,
              overflow: 'scroll'
            }}>
            {this.moreSpecificationsList()}
          </div>
          <div className="content-box">
            <CommonBtn title={'确定'} className="confirm-btn" onClick={this.confirm} />
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/ProductDetail/SkuModal/SkuModalView.js